
<template>

	<div :style="level > 0 ? 'padding-left: 8px;border-left: 5px solid ' + ( level > colors.length - 1 ? 'gray' : colors[level-1] ) : ''">

		<v-context-menu ref="context_menu">

			<b-dropdown-item v-if="selected_index != null" v-on:click="() => delete_condition(selected_index)">Удалить</b-dropdown-item>

		</v-context-menu>

		<b-button v-if="need_delete_button" size="sm" variant="light" class="filter-button" v-on:click="() => $emit('delete')" ><b-icon-trash/></b-button>

		<div class="condition_op">

			<b-dropdown v-if="conditions.length > 1" variant="outline-success" no-caret :text="op" class="condition_button" size="sm">

				<b-dropdown-item v-on:click="() => { this.op = 'И' }">И</b-dropdown-item>
				<b-dropdown-item v-on:click="() => { this.op = 'ИЛИ' }">ИЛИ</b-dropdown-item>

			</b-dropdown>

			<div class="condition_conditions">

				<div v-for="( cond, ind ) in conditions" :key="ind" class="mb-2">

					<condition v-if="cond.id" :level="level + 1" :ref="'condition_' + cond.id" :attrs="attrs" v-on:delete="() => delete_condition(ind)" v-on:need_check="() => $emit('need_check')" :in_doing="in_doing" need_delete_button/>

					<div v-else class="condition-row" v-on:contextmenu="ev => context_menu(ind, ev)">

						<v-select class="condition-row_attr" v-model="cond.attr_id" :state="cond.attr_state" :options="attrs" :reduce="obj => obj.id" label="name" :clearable="false" v-on:input="id => select_attr(cond, id)" appendToBody>

							<template #search="{ attributes, events }">

								<input class="vs__search" v-bind="attributes" v-on="events"/>
								<div v-if="! cond.attr_state" class="v_select_invalid_icon" />

							</template>

						</v-select>

						<v-select class="condition-row_op" v-if="cond.attr_id" v-model="cond.op" :state="cond.op_state" :options="cond.ops" :reduce="obj => obj.op" label="op" :clearable="false" v-on:input="op => select_op(cond, op)" appendToBody>

							<template #search="{ attributes, events }">

								<input class="vs__search" v-bind="attributes" v-on="events"/>
								<div v-if="! cond.op_state" class="v_select_invalid_icon" />

							</template>

						</v-select>

						<div class="condition-row_value" v-if="cond.attr_id && cond.op && ! cond.without_value">

							<v-select v-if="cond.reference && ( cond.op == '=' || cond.op == 'Не равно' )" :options="cond.reference" :clearable="false" :reduce="obj => obj.value" :state="cond.value_state" v-model="cond.value" v-on:input="value => set_value(cond, value)" appendToBody>

								<template #search="{ attributes, events }">

									<input class="vs__search" v-bind="attributes" v-on="events"/>
									<div v-if="! cond.value_state" class="v_select_invalid_icon" />

								</template>

							</v-select>

							<b-form-input v-else-if="cond.attr.type == 'str'" :state="cond.value_state" v-model="cond.value" v-on:input="value => set_value(cond, value)"/>
							<b-form-input v-else-if="cond.attr.type == 'number'" type="number" :state="cond.value_state" v-model="cond.value" v-on:input="value => set_value(cond, value)"/>
							<date_picker v-else-if="cond.attr.type == 'date'" :state="cond.value_state" v-model="cond.value" v-on:input="value => set_value(cond, value)"/>
							<b-form-timepicker v-else-if="cond.attr.type == 'time'" :state="cond.value_state" v-model="cond.value" v-on:input="value => set_value(cond, value)" label-no-time-selected="Значение не выбрано" label-close-button="Закрыть" label-hours="Часы" label-minutes="Минуты"/>
							<datetime_picker v-else-if="cond.attr.type == 'datetime'" :config="datetime_config" :state="cond.value_state" :value="cond.value" v-on:input="value => set_value(cond, value)"/>

						</div>

					</div>

				</div>

			</div>

		</div>

		<b-dropdown variant="outline-success" no-caret text="+ Добавить" class="condition_button" size="sm">

			<b-dropdown-item v-on:click="() => add_simple_condition()">Условие</b-dropdown-item>
			<b-dropdown-item v-on:click="() => add_condition()">Группа условий</b-dropdown-item>

		</b-dropdown>

	</div>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../api"
import date_picker from "../../widgets/date_picker"

export default
{
	name : "condition",

	props :
	{
		attrs : Array,
		attr_type : String,
		level : { type : Number, default : () => 0 },
		need_delete_button : Boolean,
		in_doing : Boolean,
	},

	components :
	{
		date_picker,
	},

	data()
	{
		return {

			colors : [ "var(--bft-blue-500)", "var(--bft-seagull-500)", "var(--bft-aquamarine-300)", "yellow", "orange", "violet" ],

			selected_index : null,

			op : "И",
			conditions : [],

			ops :
			{
				"bool" :
				[
					{ op : "Пусто", without_value : true },
					{ op : "Не пусто", without_value : true },
					{ op : "=" },
				],
				"str" :
				[
					{ op : "Пусто", without_value : true },
					{ op : "Не пусто", without_value : true },
					{ op : "=" },
					{ op : "Не равно" },
					{ op : "Содержит" },
					{ op : "Не содержит" },
					{ op : "Регулярное выражение" },
					{ op : "Начинается с" },
					{ op : "Заканчивается на" },
				],
				"str_ref" :
				[
					{ op : "Пусто", without_value : true },
					{ op : "Не пусто", without_value : true },
					{ op : "=" },
					{ op : "Не равно" },
					{ op : "Содержит" },
					{ op : "Не содержит" },
					{ op : "Регулярное выражение" },
					{ op : "Начинается с" },
					{ op : "Заканчивается на" },
				],
				"number" :
				[
					{ op : "Пусто", without_value : true },
					{ op : "Не пусто", without_value : true },
					{ op : "=" },
					{ op : "Не равно" },
					{ op : "<" },
					{ op : ">" },
					{ op : "<=" },
					{ op : ">=" },
				],
				"date" :
				[
					{ op : "Пусто", without_value : true },
					{ op : "Не пусто", without_value : true },
					{ op : "=" },
					{ op : "Не равно" },
					{ op : "<" },
					{ op : ">" },
					{ op : "<=" },
					{ op : ">=" },
				],
				"time" :
				[
					{ op : "Пусто", without_value : true },
					{ op : "Не пусто", without_value : true },
					{ op : "=" },
					{ op : "Не равно" },
					{ op : "<" },
					{ op : ">" },
					{ op : "<=" },
					{ op : ">=" },
				],
				"datetime" :
				[
					{ op : "Пусто", without_value : true },
					{ op : "Не пусто", without_value : true },
					{ op : "=" },
					{ op : "Не равно" },
					{ op : "<" },
					{ op : ">" },
					{ op : "<=" },
					{ op : ">=" },
				],
			},

			datetime_config :
			{
				locale : "ru",
				sideBySide : true,
				icons :
				{
					time : "far fa-clock",
					date : "far fa-calendar",
					up : "fas fa-arrow-up",
					down : "fas fa-arrow-down",
					previous : "fas fa-chevron-left",
					next : "fas fa-chevron-right",
					today : "fas fa-calendar-check",
					clear : "far fa-trash-alt",
					close : "far fa-times-circle"
				}
			},

		}
	},

	watch :
	{
	},

	methods :
	{
		add_simple_condition()
		{
			this.conditions.push({ attr_id : null, attr_state : false, op : null, op_state : false, ops : [], value : null, value_state : false, without_value : false, reference : null })

			this.$emit("need_check")
		},

		add_condition()
		{
			this.conditions.push({ id : uuid.v1().replaceAll("-", "_") })

			this.$emit("need_check")
		},

		delete_condition(ind)
		{
			this.conditions.splice(ind, 1)

			this.$emit("need_check")
		},

		select_attr(cond, attr_id)
		{
			cond.attr_id = attr_id
			cond.attr_state = !!attr_id

			if(cond.attr_state)
			{
				cond.attr = this.attrs.find(attr => attr.id == attr_id)

				if(cond.attr.type == "str" && cond.attr.reference != null)
				{
					cond.ops = this.ops["str_ref"]
					cond.reference = []

					cond.attr.reference.values.forEach(value => cond.reference.push({ value : value, label : api.format_reference(cond.attr.reference, value) }))
				}
				else if(cond.attr.type == "bool")
				{
					cond.ops = this.ops["bool"]
					cond.reference = [ { value : true, label : "Да" }, { value : false, label : "Нет" } ]
				}
				else
				{
					cond.ops = this.ops[cond.attr.type]
					cond.reference = null
				}
			}
			else
			{
				cond.attr = null
				cond.ops = []
				cond.reference = null
			}

			this.select_op(cond, null)
		},

		select_op(cond, op)
		{
			cond.op = op
			cond.op_state = !!op

			if(cond.op_state)
			{
				const op_desc = cond.ops.find(_op => _op.op == op)

				cond.without_value = op_desc.without_value
			}
			else
				cond.without_value = false
			
			this.set_value(cond, null)
		},

		set_value(cond, value)
		{
			if(cond.attr.type == "datetime")
				cond.value = new Date(value)
			else
				cond.value = value

			cond.value_state = cond.without_value || ( value != null && ( typeof value != "string" || value != "" ) )

			this.$emit("need_check")
		},

		get()
		{
			if(this.conditions.length == 0)
				throw "Пустое условие"

			var desc = { op : this.op, conditions : [] }

			this.conditions.forEach(
				cond =>
				{
					if(cond.id)
					{
						const key = "condition_" + cond.id

						desc.conditions.push(this.$refs[key][0].get())
					}
					else
					{
						if(cond.attr_state && cond.op_state && ( cond.without_value || cond.value_state ))
						{
							var value = cond.value

							if(cond.attr.type == "number")
								value = Number(value)
							else if(cond.attr.type == "datetime" || cond.attr.type == "date")
								value = api.date_to_iso(value)

							desc.conditions.push({ attr_id : cond.attr_id, op : cond.op, value : value })
						}
						else
						{
							console.log("ERR", cond)

							throw "Некорректное условие"
						}
					}
				})

			return desc
		},

		load(desc)
		{
			this.op = desc.op
			this.conditions = []

			desc.conditions.forEach(
				cond =>
				{
					if(cond.conditions)
					{
						const id = uuid.v1().replaceAll("-", "_")

						cond.id = id

						this.conditions.push({ id : id })
					}
					else
					{
						var new_cond = { attr_id : null, attr_state : false, op : null, op_state : false, ops : [], value : null, value_state : false, without_value : false, reference : null }

						this.select_attr(new_cond, cond.attr_id)
						this.select_op(new_cond, cond.op)
						this.set_value(new_cond, cond.value)

						this.conditions.push(new_cond)
					}
				})

			this.$nextTick(
				() =>
				{
					desc.conditions.forEach(
						cond =>
						{
							if(cond.id)
							{
								const key = "condition_" + cond.id

								this.$refs[key][0].load(cond)
							}
						})
				})
		},

		context_menu(index, event)
		{
			event.preventDefault()

			this.selected_index = index
			this.$refs.context_menu.open(event)
		},
	}
}

</script>

<style scoped>
.condition_op
{
	display: flex;
	gap: 8px;
	align-items: center;
}

.condition_conditions
{
	width: 100%;
}

.condition-row
{
	--condition-row-gap: 8px;
	display: flex;
	gap: var(--condition-row-gap);
}

.condition-row_attr
{
	width: calc(50% - (var(--condition-row-gap) / 1.5));
}
.condition-row_op
{
	width: calc(16% - (var(--condition-row-gap) / 1.5));
}
.condition-row_value
{
	width: calc(34% - (var(--condition-row-gap) / 1.5));
}

.condition-row_value input
{
	height: 100%;
}

.condition_button
{
	width: 88px;
}
</style>
